// Filter Types
export const FILTER_TEXT = "FILTER_TEXT"
export const FILTER_AUTOCOMPLETE = "FILTER_AUTOCOMPLETE"
export const FILTER_SLIDER = "FILTER_SLIDER"
export const FILTER_DATE = "FILTER_DATE"
export const FILTER_SELECT = "FILTER_SELECT"
export const FILTER_NUMBER = "FILTER_NUMBER"
